
import ChatBase from "./ChatBase.vue"

import { mapGetters } from "../../../vuex"
import { CHAT } from "../../store/modulesNames"
import { GET_CHAT_MESSAGES } from "../../store/gettersTypes"

import { msgDataTypes, msgDirection } from '../../declarations'


export default {
    name: 'Chat',
    extends: ChatBase,
    props: {
        id: Object,
    },
    // computed: {
    //     messages() {

    //     },
    //     ...mapGetters(CHAT, [GET_CHAT_MESSAGES]),
    // },
}

